// extracted by mini-css-extract-plugin
module.exports = {"fileEditor":"AdminFilesEdit_fileEditor__3XVvZ","entitySelector":"AdminFilesEdit_entitySelector__1ZbkO"};